import { render } from "./FirewallRules.vue?vue&type=template&id=149b7c7c&scoped=true"
import script from "./FirewallRules.vue?vue&type=script&lang=js"
export * from "./FirewallRules.vue?vue&type=script&lang=js"

import "./FirewallRules.vue?vue&type=style&index=0&id=149b7c7c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149b7c7c"]])

export default __exports__